import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { DetailsRenderer } from 'timeSheet/components/CellRenderers';

const useDetailsColumn = ({ setShiftModal }) => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return DetailsRenderer({
        rowData: params.data,
        columnData: { onShiftClick: setShiftModal }
      });
    },
    [setShiftModal]
  );

  return useMemo(
    () => ({
      field: 'details',
      headerName: t('details'),
      width: 200,
      sortable: false,
      initialHide: true,
      cellClass: 'justify-start',
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useDetailsColumn;
